import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold text-textPrimary text-left" }, "Exportar relatório .xlsx", -1)
const _hoisted_2 = { class: "text-left mt-[-16px] text-textPrimary" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6" }, " O relatório em formato de planilha será exportado com as configurações de visualização selecionadas. ", -1)
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center mb-3 gap-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9ZM12 4.5C17 4.5 21.27 7.61 23 12C21.27 16.39 17 19.5 12 19.5C7 19.5 2.73 16.39 1 12C2.73 7.61 7 4.5 12 4.5ZM3.18 12C4.83 15.36 8.24 17.5 12 17.5C15.76 17.5 19.17 15.36 20.82 12C19.17 8.64 15.76 6.5 12 6.5C8.24 6.5 4.83 8.64 3.18 12Z",
      fill: "#323232"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h4", { class: "font-semibold" }, "Grupos de colunas")
], -1)
const _hoisted_6 = { class: "flex flex-wrap gap-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center mb-3 gap-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M14.9999 19.88C15.0399 20.18 14.9399 20.5 14.7099 20.71C14.3199 21.1 13.6899 21.1 13.2999 20.71L9.28986 16.7C9.05986 16.47 8.95986 16.16 8.99986 15.87V10.75L4.20986 4.62C3.86986 4.19 3.94986 3.56 4.37986 3.22C4.56986 3.08 4.77986 3 4.99986 3H18.9999C19.2199 3 19.4299 3.08 19.6199 3.22C20.0499 3.56 20.1299 4.19 19.7899 4.62L14.9999 10.75V19.88ZM7.03986 5L10.9999 10.06V15.58L12.9999 17.58V10.05L16.9599 5H7.03986Z",
      fill: "#323232"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h4", { class: "font-semibold" }, "Filtros")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_9 = { class: "font-normal" }
const _hoisted_10 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_11 = { class: "flex justify-between w-full" }

import { PropType, ref } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { ReportXlxsRequest } from '@/Network/Services/ReportsService'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true
  },
  columnGroups: {
    type: Array as PropType<string[]>,
    required: true
  },
  activeFilters: {
    type: Array as PropType<{ value: any; label: string }[]>,
    required: true
  },
  rawFilters: {
    type: Object as PropType<ReportXlxsRequest>,
    required: true
  }
},
  emits: ["update:isOpen", "confirm"],
  setup(__props, { emit }) {

const props = __props;

const isLoadingBtn = ref(false)





function closeModal() {
  emit('update:isOpen', false)
}

function handleConfirmExport() {
  const payload: ReportXlxsRequest = {
    ...props.rawFilters
  }

  emit('confirm', payload)
  closeModal()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalVue, {
    "modal-active": __props.isOpen,
    onClose: closeModal,
    isFilterModal: "",
    maxWidth: "max-w-[600px]"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(OutlinedButton, {
          text: "Cancelar",
          onClick: closeModal,
          width: "100px",
          height: "48px"
        }),
        _createVNode(FilledButton, {
          text: "Exportar",
          onClick: handleConfirmExport,
          width: "100px",
          height: "48px",
          class: "!bg-primary30",
          loading: isLoadingBtn.value
        }, null, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columnGroups, (group) => {
              return (_openBlock(), _createElementBlock("span", {
                key: group,
                class: "px-3 py-0.5 text-sm bg-gray-200 text-gray-800 rounded-full"
              }, _toDisplayString(group), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          (__props.activeFilters.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.activeFilters, (filter) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: filter.label,
                    class: "px-3 py-2 text-sm border border-[#2F7F91] text-[#2F7F91] rounded-full font-bold"
                  }, [
                    _createTextVNode(_toDisplayString(filter.label) + ": ", 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(filter.value === true ? 'Sim' : filter.value === false ? 'Não' : filter.value), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_10, "Nenhum filtro adicional aplicado."))
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})